export default {
  groups: [{
      styleClasses: 'col-sm-6',
      fields: [{
          type: 'input',
          inputType: 'text',
          label: 'Name',
          model: 'name',
          maxlength: 50,
          required: true,
          placeholder: "Name of Person",
          validator: ['string'],
        },
        {
          type: 'input',
          inputType: 'text',
          label: 'Designation',
          model: 'position',
          maxlength: 100,
          required: true,
          placeholder: "Designation of Person",
          validator: ['string'],
        },
        {
          type: 'input',
          inputType: 'text',
          label: 'Company',
          model: 'company',
          maxlength: 100,
          required: true,
          placeholder: "Company",
          validator: ['string']
        },
        {
          type: "cropper",
          model: 'image',
          package: 'croppie',
          label: 'Photo',
          required: true,
          options: {
            aspect: 1,
            width: 300,
            height: 300,
            resizable: false,
          }
        },
      ]
    },
    {
      styleClasses: 'col-sm-6',
      fields: [{
          type: "textArea",
          label: "Testimonial",
          model: "brief",
          placeholder: "Testimonial",
          rows: 4,
          validator: ['string']
        },
        {
          type: "select",
          label: "Status",
          model: "status",
          values: [
            "active",
            "inactive"
          ],
        }
      ]
    }
  ]
}